import React from "react";

import { TrackingObject } from "../../types/TrackingTypes";
import NewsletterModal from "./NewsletterModal";
import EmailCaptureSuccessModal from "./EmailCaptureSuccessModal";

interface NewsletterProps {
    handleModalFormClose?: () => void;
    handleModalFormSubmit: (values: object) => Promise<boolean>;
    handleModalFormSubmitSuccess?: () => void;
    handleModalFormSubmitError?: () => void;
    handleSuccessModalClose?: () => void;
    handleSuccessModalButtonClicked?: () => void;
    trackingOverrides?: TrackingObject;
    clickTrackingOverrides?: TrackingObject;
    impressionTrackingOverrides?: TrackingObject;
    setShowFormModal: (value: boolean) => void;
    showFormModal?: boolean;
    newsletterRef?: (node: HTMLDivElement) => void;
    successRef?: (node: HTMLDivElement) => void;
}

const Newsletter = (props: NewsletterProps) => {
    const {
        handleModalFormClose = () => {},
        handleModalFormSubmit,
        handleModalFormSubmitSuccess = () => {},
        handleModalFormSubmitError = () => {},
        handleSuccessModalClose = () => {},
        trackingOverrides,
        impressionTrackingOverrides,
        clickTrackingOverrides,
        setShowFormModal,
        showFormModal = false,
        newsletterRef,
        successRef
    } = props;

    const initialTracking = {
        sp_page_type: "content",
        sp_page_section: "advice",
        sp_page_company_id: null,
        sp_page_tab: null,
        sp_page_is_external: false,
        ...(trackingOverrides || {})
    };

    const impressionTrackingData = {
        ...initialTracking,
        sp_impression_component: "modal",
        sp_impression_position: "pop_up",
        ...(impressionTrackingOverrides || {})
    };

    const clickTrackingData = {
        ...initialTracking,
        sp_modal_type: "newsletter",
        sp_modal_job_category: null,
        sp_modal_job_location: null,
        sp_modal_newsletter_opt_in: null,
        sp_modal_error_type: null,
        ...clickTrackingOverrides,
    };

    const [showSuccessModal, setShowSuccessModal] = React.useState(false);

    const newsletterModalProps = {
        onClose: () => {
            setShowFormModal(false);
            handleModalFormClose();
        },
        isOpen: showFormModal,
        setIsOpen: setShowFormModal,
        onFormSubmit: (values: object) => handleModalFormSubmit(values).then((isSuccess: boolean) => {
            // If form submission returns 201 response show success modal
            if (isSuccess) {
                setShowFormModal(false);
                setShowSuccessModal(true);
                handleModalFormSubmitSuccess();
            } else {
                // Do something to display error
                handleModalFormSubmitError();
            }
            return isSuccess;
        }),
        impressionTrackingProps: {
            ...impressionTrackingData,
            sp_impression_modal_type: "newsletter",
        },
        submitTrackingProps: {
            ...clickTrackingData,
            sp_modal_action_type: "submit"
        },
        closeTrackingProps: {
            ...clickTrackingData,
            sp_modal_action_type: "close"
        },
        newsletterRef
    };

    const newsletterSuccessProps = {
        headerText: "You're In.",
        // eslint-disable-next-line max-len
        successText: "Success! We’ll start sending you emails within the next few days. In the meantime, you can explore expert advice that’s already on The Muse.",
        imgUrl: "https://cms-assets.themuse.com/media/woman_working_on_job_applications.jpg",
        isOpen: showSuccessModal,
        setIsOpen: setShowSuccessModal,
        onClose: () => {
            setShowSuccessModal(false);
            handleSuccessModalClose();
        },
        impressionTrackingProps: {
            ...impressionTrackingData,
            sp_impression_modal_type: "newsletter_success",
        },
        successRef
    };

    return (
        <>
            {showFormModal && <NewsletterModal {...newsletterModalProps} />}
            {showSuccessModal && <EmailCaptureSuccessModal {...newsletterSuccessProps} />}
        </>
    );
};

export { Newsletter as default };
export type { NewsletterProps };
